import React from "react";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
  holidayTypes = [],
}) => {
  return (
    <tr>
      <td>
        <input
          type="text"
          required="required"
          placeholder="Enter holiday name"
          name="holiday_name"
          value={editFormData.holiday_name || ""}
          onChange={handleEditFormChange}
          className="form-control form-control-sm"
        />
      </td>
      <td>
        <input
          type="date"
          required="required"
          name="holiday_date"
          value={editFormData.holiday_date || ""}
          onChange={handleEditFormChange}
          className="form-control form-control-sm"
        />
      </td>
      <td>
        <input
          type="text"
          disabled
          value={
            editFormData.holiday_date
              ? new Date(editFormData.holiday_date).toLocaleDateString(
                  "en-US",
                  { weekday: "long" }
                )
              : ""
          }
          className="form-control form-control-sm"
          style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
        />
      </td>
      <td>
        <select
          name="holiday_type"
          required="required"
          value={editFormData.holiday_type || "National Holiday"}
          onChange={handleEditFormChange}
          className="form-control form-control-sm"
        >
          {holidayTypes.map((type) => (
            <option key={type} value={type}>
              {type}
            </option>
          ))}
        </select>
      </td>
      <td style={{ textAlign: "center" }}>
        <div className="d-flex gap-2 justify-content-center">
          <button
            type="submit"
            className="btn btn-sm btn-success"
            style={{ minWidth: "60px" }}
          >
            Save
          </button>
          <button
            type="button"
            onClick={handleCancelClick}
            className="btn btn-sm btn-secondary"
            style={{ minWidth: "60px" }}
          >
            Cancel
          </button>
        </div>
      </td>
    </tr>
  );
};

export default EditableRow;
